import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

export const configurableProductsAccessControl: DomainAccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.ConfigurableProducts],
  permissions: [Permission.ConfigurableProductsModify, Permission.CatalogProductsView],
  restrictedBannersAllowed: true,
}
